import { TRACKING_STATUS_OPTIONS } from './packageTrack';

const PACKAGE_CODE_RE = /^[A-Z0-9][A-Z0-9-]{2,39}$/;
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const TIME_RE = /^\d{2}:\d{2}$/;

const VALID_STATUSES = new Set(TRACKING_STATUS_OPTIONS.map((s) => s.value));

export function normalizePackageCode(code) {
  return String(code || '').trim().toUpperCase();
}

export function validatePackageCode(code) {
  const normalized = normalizePackageCode(code);
  if (!normalized) {
    return { ok: false, message: 'Package code is required' };
  }
  if (!PACKAGE_CODE_RE.test(normalized)) {
    return {
      ok: false,
      message: 'Invalid package code format (e.g. 01818-01 or COL-01818-01)',
    };
  }
  if (!normalized.includes('-')) {
    return { ok: false, message: 'Package code must include a sub number (e.g. 01818-01)' };
  }
  return { ok: true, code: normalized };
}

export function validateEventDateTime(eventDate, eventTime, { required = true } = {}) {
  const dateStr = String(eventDate || '').trim();
  const timeStr = String(eventTime || '').trim();

  if (!dateStr) {
    if (!required) return { ok: true };
    return { ok: false, message: 'Date is required' };
  }

  if (!DATE_RE.test(dateStr)) {
    return { ok: false, message: 'Invalid date format' };
  }

  if (timeStr && !TIME_RE.test(timeStr)) {
    return { ok: false, message: 'Invalid time format (use HH:MM)' };
  }

  const iso = timeStr ? `${dateStr}T${timeStr}:00` : `${dateStr}T12:00:00`;
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) {
    return { ok: false, message: 'Invalid date or time' };
  }

  const [y, m, d] = dateStr.split('-').map(Number);
  if (parsed.getFullYear() !== y || parsed.getMonth() + 1 !== m || parsed.getDate() !== d) {
    return { ok: false, message: 'Invalid calendar date' };
  }

  if (parsed.getTime() > Date.now() + 60_000) {
    return { ok: false, message: 'Event date and time cannot be in the future' };
  }

  return { ok: true };
}

export function validateTrackingStatus(status) {
  const value = String(status || '').trim();
  if (!value) {
    return { ok: false, message: 'Status is required' };
  }
  if (!VALID_STATUSES.has(value)) {
    return { ok: false, message: 'Invalid tracking status' };
  }
  return { ok: true, status: value };
}

export function validateScanForm({ code, status, eventDate, eventTime }) {
  const codeResult = validatePackageCode(code);
  if (!codeResult.ok) return codeResult;

  const statusResult = validateTrackingStatus(status);
  if (!statusResult.ok) return statusResult;

  const dtResult = validateEventDateTime(eventDate, eventTime, { required: true });
  if (!dtResult.ok) return dtResult;

  return { ok: true, code: codeResult.code };
}

export function validateBulkTrackingForm({ status, eventDate, eventTime }) {
  const statusResult = validateTrackingStatus(status);
  if (!statusResult.ok) return statusResult;

  const dtResult = validateEventDateTime(eventDate, eventTime, { required: true });
  if (!dtResult.ok) return dtResult;

  return { ok: true };
}
